import { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { useSelector } from "react-redux";
import { useDirect } from "../../hooks";
import keyNames from "../../keyName";
import ModalContent from "./ModalContent";

const CustomDialog = () => {
  const directDispatch = useDirect();
  const stateData = useSelector((state) => state.mainReducer);
  const { dialogData } = stateData;
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
    directDispatch(null, keyNames.dialogData);
  };
  useEffect(() => {
    if (!dialogData) {
      setOpen(false);
      return;
    }
    setOpen(dialogData?.showdialog);
  }, [dialogData]);
  return (
    <Dialog
      open={open}
      onClose={dialogData?.addOnClose && handleClose}
      className={dialogData?.className}
      {...dialogData?.dialogProps}
    >
      {dialogData && (
        <ModalContent handleClose={handleClose} dialogData={dialogData} />
      )}
    </Dialog>
  );
};

export default CustomDialog;
